import React, { useState, useEffect } from "react";
import { styled } from '@mui/material/styles';
import { Switch, Slider, Typography, Box } from '@mui/material';
import { useSelector } from "react-redux";

const LampControl = ({ lamp }) => {
  const [isOn, setIsOn] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [dimming, setDimming] = useState(0);

  const user = useSelector(state => state.auth.user);

  console.log(`user: ${user}`);

  useEffect(() => {
    if (!lamp?.devEUNumber) return;

    setDimming(prev => {
      if (lamp.currentDimming == null) return prev;
      if (prev === lamp.currentDimming) return prev;
      return lamp.currentDimming;
    });

    setIsOn(lamp.status === "active");

  }, [lamp.currentDimming, lamp.status]);

  const sendCommand = async (command) => {
    try {
      setDisabled(true);

      const payload = {
        user: user,
        devEUNumber: lamp.devEUNumber,
        command,
      };

      if (command === "on") {
        payload.dimming = dimming;
      }

      await fetch(
        "https://commandserver-smartlight.apps.okd-prod.smart-iot.bhtelecom.ba/api/smartlampcontrol",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        }
      );

      if (command === "off") {
        setIsOn(false);
        setDimming(0);
      } else if (command === "on") {
        setIsOn(true);
      } else if (!isNaN(command)) {
        setIsOn(true);
        setDimming(Number(command));
      }

    } catch (e) {
      console.error(e);
    } finally {
      setTimeout(() => setDisabled(false), 600);
    }
  };

  const IOSSwitch = styled(Switch)(() => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
      padding: 1,
      '&.Mui-checked': {
        transform: 'translateX(16px)',
        color: '#ff9800',
        '& + .MuiSwitch-track': {
          backgroundColor: '#4CAF50',
        },
      },
    },
    '& .MuiSwitch-thumb': {
      width: 22,
      height: 22,
      backgroundColor: '#ff9800',
    },
    '& .MuiSwitch-track': {
      borderRadius: 13,
      backgroundColor: '#ff9800',
    },
  }));

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
        minWidth: "220px",
        p: 1.5,
        borderRadius: "14px",
        backgroundColor: '#0f172a',
        border: '1px solid #3949ab33',

        // 🔥 glow po dimmingu
        boxShadow:
          lamp.status === "active"
            ? `
              0 0 ${4 + dimming * 0.2}px rgba(250,204,21,${0.2 + dimming / 250}),
              0 0 ${10 + dimming * 0.4}px rgba(250,204,21,${0.1 + dimming / 300})
            `
            : lamp.status === "alarm"
              ? "0 0 14px rgba(220,38,38,0.7)"
              : "0 4px 20px rgba(0,0,0,0.4)",

        // 🔥 disable look kad je alarm
        opacity: lamp.status === "alarm" ? 0.6 : 1,
        pointerEvents: lamp.status === "alarm" ? "none" : "auto",

        transition: "all 0.3s ease"
      }}
    >

      {/* HEADER */}
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>

          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              backgroundColor:
                lamp.status === "active"
                  ? "#facc15"
                  : lamp.status === "inactive"
                    ? "#6b7280"
                    : "#dc2626",

              animation: lamp.status === "alarm"
                ? "pulse 1s infinite"
                : "none"
            }}
          />

          <Typography sx={{ color: "#ff9800", fontSize: "13px" }}>
            Lamp
          </Typography>

        </Box>

        <IOSSwitch
          checked={isOn}
          disabled={disabled || lamp.status === "alarm"}
          onChange={(e) => {
            const checked = e.target.checked;
            setIsOn(checked);

            if (checked) {
              setDimming(100);
              sendCommand("on");
            } else {
              setDimming(0);
              sendCommand("off");
            }
          }}
        />
      </Box>

      {/* DIMMING */}
      <Box>
        <Typography sx={{ color: "#ff9800", fontSize: "11px", mb: 0.5 }}>
          Level: {dimming}%
        </Typography>

        <Slider
          value={dimming}
          onChange={(e, v) => setDimming(v)}
          onChangeCommitted={(e, v) => sendCommand(v.toString())}
          disabled={disabled || !isOn || lamp.status === "alarm"}
          min={0}
          max={100}
          step={1}
          size="small"
          sx={{
            color:
              lamp.status === "active"
                ? `rgba(250,204,21,${0.4 + dimming / 200})`
                : lamp.status === "alarm"
                  ? "#dc2626"
                  : "#6b7280"
          }}
        />
      </Box>

      {/* ANIMATION */}
      <style>
        {`
          @keyframes pulse {
            0% { opacity: 1; }
            50% { opacity: 0.3; }
            100% { opacity: 1; }
          }
        `}
      </style>

    </Box>
  );
};

export default LampControl;